const IMAGES_DELIMITER = '|';

export const extractCoverImages = (coverImageField) => {
    let images = [];
    let selectedCoverImage = null;

    if (coverImageField && coverImageField.includes(IMAGES_DELIMITER)) {
        images = coverImageField.split(IMAGES_DELIMITER).filter(url => url);
        selectedCoverImage = images[0] || null;
    } else if (coverImageField) {
        selectedCoverImage = coverImageField;
        images = [coverImageField];
    }

    return {
        images,
        selectedCoverImage
    };
};

export const combineCoverImages = (images, selectedImage) => {
    let imagesList = [...images];

    if (selectedImage && imagesList.includes(selectedImage) && imagesList[0] !== selectedImage) {
        imagesList = imagesList.filter(img => img !== selectedImage);
        imagesList.unshift(selectedImage);
    } else if (selectedImage && !imagesList.includes(selectedImage)) {
        imagesList.unshift(selectedImage);
    }

    imagesList = [...new Set(imagesList)];

    return imagesList.length > 0 ? imagesList.join(IMAGES_DELIMITER) : '';
};
